import(/* webpackMode: "eager" */ "/vercel/path0/app/[locale]/acceso/page.jsx");
